<!-- src/pages/budgets/create.vue -->
<template>
  <form @submit.prevent="handleSubmit">
    <section class="page-header mb-3">
      <div class="container d-flex justify-content-between align-items-end">
        <div class="page-header-title">
          <h1 class="h3 mb-1">
            <i class="fa-solid fa-layer-group"></i>
            {{ $t('page.budgets.create_title') }}
          </h1>
          <p class="text-light opacity-75 mb-0">{{ $t('page.budgets.index_description') }}</p>
        </div>
        <div class="page-header-actions">
          <button class="btn btn-sm btn-primary me-2" id="home" @click.prevent="handleIndex()"
            :title="$t('common.home')">
            <i class="fa fa-home"></i> {{ $t('common.home') }}
          </button>
          <button class="btn btn-sm btn-success" id="save" type="submit" :title="$t('common.save')">
            <i class="fa fa-save"></i>
          </button>
          <button class="btn btn-sm btn-primary d-sm-none ml-1" @click="toggleFilters" :title="$t('common.filter')">
            <i class="fa-solid fa-filter"></i>
          </button>
        </div>
      </div>
    </section>

    <div class="container">
      <div class="card">
        <div class="card-body">
          <Form v-model:form="form" :errors="errors" />
        </div>
      </div>
    </div>
  </form>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from 'vue-router';
import { useProjectStore } from '@/stores/projectStore';
import { useI18n } from 'vue-i18n';
import { toast } from 'vue3-toastify';
import Form from './_form';

const router = useRouter();
const projectStore = useProjectStore();
const { t } = useI18n();
const form = ref({});
const errors = ref({});

// Submit
const handleSubmit = async () => {
  try {
    await projectStore.createProject(form.value);
    await toast.success(t('common.created'), { autoClose: 3000 });
    router.push({ name: 'projects-index' });
  } catch (error) {
    if (error.response.data.errors) {
      errors.value = error.response.data.errors;
    }
    toast.error(t('common.createError'));
  }
};

// Go to Index
const handleIndex = () => {
  router.push({ name: "projects-index" });
};
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #2c3e50, #4a6580);
  color: white;
  padding: 20px 0;
}

.page-filters {
  background: white;
  border-radius: 12px;
}

.fa-spin {
  margin: 10px 0;
}
</style>
